export type EventPendingActionKind = 'join' | 'leave' | 'confirm' | 'cancel';

export function getEventActionConfirmCopy(kind: EventPendingActionKind): {
  title: string;
  message: string;
  confirmLabel: string;
  destructive: boolean;
} {
  if (kind === 'join') {
    return {
      title: 'Вступить в событие',
      message: 'Подтвердить вступление в это мероприятие?',
      confirmLabel: 'Подтвердить',
      destructive: false,
    };
  }

  if (kind === 'confirm') {
    return {
      title: 'Подтвердить участие',
      message: 'Подтвердить участие в этом мероприятии?',
      confirmLabel: 'Подтвердить',
      destructive: false,
    };
  }

  if (kind === 'cancel') {
    return {
      title: 'Отменить мероприятие',
      message: 'Отменить это мероприятие? Это действие нельзя отменить.',
      confirmLabel: 'Отменить',
      destructive: true,
    };
  }

  return {
    title: 'Выйти из события',
    message: 'Подтвердить выход из этого мероприятия?',
    confirmLabel: 'Выйти',
    destructive: true,
  };
}
